import AbstractSymbolBehaviour from "slotworks/components/matrix/symbol/behaviours/abstract-symbol-behaviour";
import Contract from "slotworks/utils/contracts/contract";
import Components from "slotworks/components/components";
import { getTotalPicks } from "utils/calculate-picks-remaining";

export default class MCSymbolCountBehaviour extends AbstractSymbolBehaviour {
    public behaviourName: string = "MCSymbolCount";
    public land(): Contract<void> {
        // Components.betBar.setTotalFreespins(getTotalPicks());
        return Contract.empty();
    }
}
